export var LOG_PREFIX = 'storage:localstorage: ';
export var DEFINED = '1';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/storages/inLocalStorage/constants.js
// module id = 1312
// module chunks = 25